import { useMemo, useState } from 'react'
import { Box, Button, Heading } from '@grupoboticario/flora-react'
import { useTranslation } from 'react-i18next'

import Stepper from './Stepper'
import { useTracking } from '../TrackingContext'

const Updates = () => {
  const [open, setOpen] = useState(false)
  const data = useTracking()
  const { t } = useTranslation()

  const listItem = (item: TTracking, index: number) => {
    const rawDate = item.dtOcorrencia.split(' ')
    const date = rawDate[0].split('-').reverse().join('/')
    const dateTime = `${date} ${rawDate[1]}`

    const getClassName = () => {
      if (!!item.tabSituacaoPedido.nrAlerta && index === 0) return 'error'
      if (!!item.tabSituacaoPedido.nrAlerta) return 'warning'
      return ''
    }

    return {
      className: getClassName(),
      title: (
        <>
          {dateTime} {<span className="highlight">{item.tabSituacaoPedido.nmSituacaoPedido}:</span>}
          {item.nmObservacao || ''} {item.nmMensagem || ''}
        </>
      )
    }
  }

  const steps = useMemo(() => {
    if (!data) return []

    const occurrences = data.orderTraceabilityModel.orqOcorrenciaFrete ?? []
    const sorted = occurrences.slice().sort((a: TTracking, b: TTracking) => {
      if (a.dtOcorrencia < b.dtOcorrencia) return -1
      if (a.dtOcorrencia > b.dtOcorrencia) return 1
      return 0
    })
    const reversed = sorted.reverse()
    const list = reversed.map((item: TTracking, index: number) => listItem(item, index))

    return list
  }, [data])

  if (!data) return <div />

  return (
    <Box>
      <Heading as="h2" css={{ fontSize: '24px', lineHeight: '28px', fontWeight: 500, marginBottom: '24px' }}>
        {t('updates')}
      </Heading>

      <Box className={open || steps.length < 6 ? 'toggled' : 'toggled closed'} css={{ position: 'relative' }}>
        <Stepper steps={steps} vertical />
        {!open && steps.length > 5 && <div className="gradient" />}
      </Box>

      {steps.length > 5 && (
        <Button
          isFull
          variant="ghost"
          shape="sharp"
          css={{
            border: 'none',
            boxShadow: 'none',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: 'transparent',
              color: 'var(--flora--colors-actionNavigationStandardHighlight)',
              boxShadow: 'none'
            }
          }}
          onClick={() => setOpen(!open)}
        >
          {t('see')} {!open ? t('more') : t('less')}
        </Button>
      )}
    </Box>
  )
}

export default Updates
